import CatalogLayout from 'components/Catalog/CatalogLayout/CatalogLayout';

export default CatalogLayout;
